module.exports = __webpack_public_path__ + "img/bebidasImage.3b9e4ccd.svg";